// extracted by mini-css-extract-plugin
export default {"loadingContainer":"style_loadingContainer__FSuiw","loadingIcon":"style_loadingIcon__EXile"};